import { useCallback } from "react";

import { RouteBuilders } from "@simplyk/common";
import { useRouter } from "next/router";

import { useLocaleContext } from "@/contexts/LocaleContext";
import { useUrlBuilder } from "@/hooks/useUrlBuilder";

export const useOpenPeerToPeerRegistrationForm = (ticketingId?: string) => {
  const { isoLocale } = useLocaleContext();
  const router = useRouter();

  const urlBuilder = useUrlBuilder();

  const ticketingUrl = ticketingId
    ? urlBuilder({
        route: RouteBuilders.buildTicketingFormLink({ isoLocale, ticketingId }),
        searchParams: {
          isPeerToPeerV2: "true",
        },
      })
    : undefined;

  return useCallback(() => {
    if (ticketingUrl) {
      router.push(ticketingUrl);
    }
  }, [router, ticketingUrl]);
};
